// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.error-card {
  border-radius: 1rem;
}

.error-icon-wrap {
  width: 84px;
  height: 84px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: #fff;
}

.error-tone-client {
  background: #dc3545;
}

.error-tone-auth {
  background: #17a2b8;
}

.error-tone-authz {
  background: #6f42c1;
}

.error-tone-not-found {
  background: #343a40;
}

.error-tone-warning {
  background: #fd7e14;
}

.error-tone-server {
  background: #dc3545;
}

.error-tone-maintenance {
  background: #007bff;
}

.error-badge {
  font-size: 0.78rem;
  letter-spacing: 0.04em;
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
}

.error-illustration {
  max-width: 25%;
  height: auto;
}

@media (max-width: 576px) {
  .error-illustration {
    max-width: 60%;
  }
}
@media (max-width: 992px) {
  .error-illustration {
    max-width: 40%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/error-page/error-page.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kFAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,cAAA;EACF;AACF;AAEA;EACE;IACE,cAAA;EAAF;AACF","sourcesContent":[".error-page {\n  min-height: 100vh;\n  background: #f8f9fa;\n}\n\n.error-card {\n  border-radius: 1rem;\n}\n\n.error-icon-wrap {\n  width: 84px;\n  height: 84px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  color: #fff;\n}\n\n.error-tone-client {\n  background: #dc3545;\n}\n\n.error-tone-auth {\n  background: #17a2b8;\n}\n\n.error-tone-authz {\n  background: #6f42c1;\n}\n\n.error-tone-not-found {\n  background: #343a40;\n}\n\n.error-tone-warning {\n  background: #fd7e14;\n}\n\n.error-tone-server {\n  background: #dc3545;\n}\n\n.error-tone-maintenance {\n  background: #007bff;\n}\n\n.error-badge {\n  font-size: 0.78rem;\n  letter-spacing: 0.04em;\n}\n\n.font-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", monospace;\n}\n\n.error-illustration {\n  max-width: 25%;\n  height: auto;\n}\n\n@media (max-width: 576px) {\n  .error-illustration {\n    max-width: 60%;\n  }\n}\n\n@media (max-width: 992px) {\n  .error-illustration {\n    max-width: 40%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
